import { type SxProps, type Theme } from '@mui/material'

export const styles = {
  shell: {
    borderRadius: '12px',
    overflow: 'hidden',
    border: '4px solid var(--blue-500)'
  } satisfies SxProps<Theme>,
  content: {
    flex: 1,
    minWidth: 0,
    backgroundColor: 'var(--blue-50)'
  } satisfies SxProps<Theme>,
  filterBar: {
    backgroundColor: 'var(--white)',
    borderBottom: '1px solid var(--border)',
    px: '24px',
    py: '12px'
  } satisfies SxProps<Theme>,
  panels: {
    p: '24px'
  } satisfies SxProps<Theme>
}
